import {useRoute} from "vue-router";
import {computed, ref, watch} from "vue";
import {utilities} from "@/niftybit";
import axios from "axios";

export default {
    value: (key) => {
        const route = useRoute();
        const responseValue = ref(undefined);

        function reload() {
            if (route.params.communityId) {
                axios.get(utilities.path('communities/@/usages/@', route.params.communityId, key)).then(response => {
                    responseValue.value = response.data;
                });
            }
        }

        watch(() => route.params.communityId, () => {
            if (route.params.communityId) {
                reload();
            }
        }, {
            immediate: true
        });
        return computed(() => ({
            value: responseValue.value,
            reload: reload
        }));
    },
    format(unit, value) {
        if (unit === "byte") {
            return value >= 1000000000 ? Math.round(value / 1000000000 * 10) / 10 + " GB" : value > 1000000 ? Math.round(value / 1000000 * 10) / 10 + " MB" : value > 1000 ? Math.round(value / 1000 * 10) / 10 + " KB" : value + " B";
        }
        return value;
    }
}